import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import ogThumbnail from '@/assets/gift-cards/og-thumbnail.gif';
import HeadMeta from '@/components/static-pages/HeadMeta';
import GiftCardsTemplate from '@/components/templates/gift-cards/GiftCardsTemplate';
import type { TPageWithHeader } from '@/components/ui/GlobalHeader/GlobalHeaderV2/headerConfig';
import { getStaticPageData } from '@/services/getPageData';

export interface IGiftCardsProps {
  title: string;
  description: string;
  url: string;
  noindex: boolean;
}

const GiftCards: NextPage<IGiftCardsProps> & TPageWithHeader = props => {
  const { title, description, url, noindex } = props;

  return (
    <>
      <HeadMeta
        title={title}
        description={description}
        url={url}
        noindex={noindex}
        thumbnailURL={ogThumbnail}
      />
      <GiftCardsTemplate {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const pageData = await getStaticPageData({ locale, url_path: 'gift-cards' });
  if (isEmpty(pageData) || isEmpty(pageData.metadata)) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const { seo_title, seo_description, url, title } = pageData.metadata;

  return {
    props: {
      title: seo_title ?? title,
      description: seo_description,
      url,
      noindex: !!pageData.fallback,
    },

    revalidate: 20,
  };
};

GiftCards.header = { preset: 'gift-cards' };

export default GiftCards;
